module.exports = __webpack_public_path__ + "img/img4.0d687b23.png";